// Render the html of a corporate question config option
export default ngModule => {

    ngModule.directive('corporateQuestionLabel', (AonConfig) => {
        return {
            restrict: 'E',
            scope: {
                // The name of a caption field on the CorporateQUestionConfig model, e.g. "step_1_who_caption"
                question: '@'
            },
            template: '<span ng-bind-html="questionHTML"></span>',
            link: (scope) => {
                scope.questionHTML = AonConfig.corporate.questionConfig[scope.question];
            },
        };
    });

}



// WEBPACK FOOTER //
// ./src/directives/corporate-question-label.js